import { coreAxios } from "@/declare/api/axios"
import { Project } from "@/declare/interface/project/project"
import { AxiosResponse } from "axios"

/**
 * 添加项目
 * @param data 项目信息
 * @returns
 */
export function createProject(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取项目列表（通过请求头发送相应信息）
 * @returns
 */
export function findProjects(projectGroupUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/project-groups/${projectGroupUuid}/projects`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取当前用户的项目列表
 * @returns
 */
export function findProjectsByUser(projectGroupUuid: string, userUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/project-groups/${projectGroupUuid}/projects/user`, {
        params: {
            ...params,
            userUuid: userUuid,
        }
    })
}

/**
 * 获取项目详情
 * @param uuid 项目uuid
 * @returns
 */
export function findProjectDetail(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${uuid}`, {
        params: {
            ...params,
        }
    })
}
/**
 * 更新项目
 * @param uuid 项目uuid
 * @param data 新的项目信息
 * @returns
 */
export function updateProject(uuid: string, data: Project, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/projects/${uuid}/update`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除项目
 * @param uuid 项目uuid
 * @returns
 */
export function deleteProject(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${uuid}/delete`, {
        params: {
            ...params,
        }
    })
}